import { createSelector, Selector } from '@reduxjs/toolkit';
import { SensorTypes } from 'commons/src/models/commonEnums';
import { IndoorSpace } from '../../../models/spaceModels';
import { Store } from '../../../reducers';

type CustomThresholds = {
    name: string;
    id: string;
    sensors: SensorTypes[];
};
const selectSpaceCustomThresholds = (state: Store, buildingId: string): CustomThresholds[] => {
    const locationSpaces = state.spaces.spaces[buildingId];
    const spacesWithCustomThresholds = locationSpaces?.spaces.filter(
        space => !!(space as IndoorSpace).customThresholds
    );
    return (
        spacesWithCustomThresholds?.map(space => {
            const customThresholds = (space as IndoorSpace).customThresholds || {};
            return {
                name: space.name,
                id: space.id,
                sensors: Object.keys(customThresholds).map(sensor => sensor as SensorTypes),
            };
        }) ?? []
    );
};

const makeCustomThresholdSelector = (buildingId: string): Selector<Store, CustomThresholds[]> =>
    createSelector(
        [(state: Store): CustomThresholds[] => selectSpaceCustomThresholds(state, buildingId)],
        (customThresholds: CustomThresholds[]) => customThresholds
    );

export { makeCustomThresholdSelector, selectSpaceCustomThresholds };
